import React from 'react'
import { useTranslation } from 'react-i18next'
import PersonChangesLabelAndData from './PersonChangesLabelAndData'
import MoreMetadataButton from '../../common/buttons/MoreMetadataButton'
import PersonChangesMoreMetadataDialog from './PersonChangesMoreMetadataDialog'
import { enumToCamelCase } from '../../../util/StringUtil'
import { toLocaleString } from '../../../util/DateUtil'

function MetadataCell({ metadata, idsMetadata, displayChangeMessage }) {
  const { t } = useTranslation()
  return (
    <>
      {metadata.title && (
        <PersonChangesLabelAndData
          label={t('title', 'Title')}
          data={metadata.op ? t(`person.changes.${metadata.op}`, enumToCamelCase(metadata.op)) : metadata.title}
          idsMetadata={idsMetadata}
        />
      )}
      {metadata.attribution.contributorId !== metadata.attribution.submitterId ? (
        <>
          {metadata.attribution.contributorId && (
            <PersonChangesLabelAndData
              label={t('contributorId', 'Contributor ID')}
              data={metadata.attribution.contributorId}
              idsMetadata={idsMetadata}
            />
          )}
          {metadata.attribution.submitterId && (
            <PersonChangesLabelAndData
              label={t('person.submitterId.label', 'Submitter ID')}
              data={metadata.attribution.submitterId}
              idsMetadata={idsMetadata}
            />
          )}
        </>
      ) : (
        <PersonChangesLabelAndData
          label={t('by.label', 'By')}
          data={metadata.attribution.contributorId}
          idsMetadata={idsMetadata}
        />
      )}
      {metadata.attribution.modifiedDateString && (
        <PersonChangesLabelAndData
          label={t('modified.label', 'Modified')}
          data={toLocaleString(new Date(metadata.attribution.modifiedDateMilliseconds), true)}
          idsMetadata={idsMetadata}
        />
      )}
      {metadata.attribution.agentAppId && (
        <PersonChangesLabelAndData
          label={t('agentApp', 'Agent App')}
          data={metadata.attribution.agentAppId}
          idsMetadata={idsMetadata}
        />
      )}
      {metadata.attribution.changeMessage &&
        metadata.attribution.changeMessage !== 'undefined' &&
        displayChangeMessage && (
          <PersonChangesLabelAndData
            label={t('changeMessage', 'Change Message')}
            data={metadata.attribution.changeMessage}
            idsMetadata={idsMetadata}
          />
        )}
      <MoreMetadataButton
        MetadataDialog={PersonChangesMoreMetadataDialog}
        metadata={metadata}
        idsMetadata={idsMetadata}
      />
    </>
  )
}

export default MetadataCell
